import { Check, Circle, Hourglass, Loader2, X } from 'lucide-react';

import type { PhaseState } from './run-phase-summary';

/** Glyph + tone per phase state, so the state reads at a glance and not only by colour. */
export const STATE_ICON: Record<PhaseState, { Icon: typeof Check; className: string }> = {
  done: { Icon: Check, className: 'text-success' },
  running: { Icon: Loader2, className: 'text-info animate-spin' },
  waiting: { Icon: Hourglass, className: 'text-warning' },
  failed: { Icon: X, className: 'text-error' },
  notStarted: { Icon: Circle, className: 'text-muted-foreground/50' },
  skipped: { Icon: Circle, className: 'text-muted-foreground/50' },
};

/** Status glyph per raw stage status, for the compact "Stages ▸" list. */
export const STAGE_ICON: Record<string, PhaseState> = {
  COMPLETED: 'done',
  SKIPPED: 'skipped',
  RUNNING: 'running',
  AWAITING_GATE: 'waiting',
  FAILED: 'failed',
  RECONCILE_FAILED: 'failed',
};
